import React from 'react';
import { ShieldCheck, Download, Users } from 'lucide-react';
export function Hero() {
  return <section className="bg-navy-800 pt-[96px] pb-[96px] px-6 relative border-b border-teal-400/30 overflow-hidden" data-id="element-128">
      <div className="max-w-[1100px] mx-auto grid lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-129">
        {/* Left Column - Text */}
        <div className="flex flex-col items-start text-left" data-id="element-130">
          <div className="bg-teal-400/10 border border-teal-400 text-teal-400 uppercase text-[11px] font-bold tracking-widest px-4 py-1.5 rounded-full mb-8" data-id="element-131">
            FOR THE 800 MILLION WHO CAN'T SLEEP THROUGH BACK PAIN
          </div>

          <h1 className="font-serif text-white text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.1] mb-6" data-id="element-132">
            Why Your Back Pain Is Always Worst At{' '}
            <span className="text-teal-400 italic" data-id="element-133">11PM</span> — And The{' '}
            <span className="text-teal-400 italic" data-id="element-134">12-Minute</span> Floor
            Protocol That Stops It Tonight
          </h1>

          <p className="font-sans text-white/72 text-[18px] max-w-[520px] mb-10 leading-relaxed" data-id="element-135">
            Discover the Somatic Fusion Method™ — a proven bedtime sequence
            that interrupts the nervous system pain loop so you can finally
            sleep through the night.
          </p>

          <a href="#final-cta" className="inline-flex items-center justify-center w-full sm:w-auto px-10 h-[64px] bg-gold text-navy-800 font-bold text-[17px] uppercase rounded-[14px] shadow-[0_8px_40px_rgba(201,168,76,0.4)] hover:brightness-110 hover:scale-[1.02] transition-all mb-6" data-id="element-136">
            Get Instant Access — $9.87
          </a>

          <div className="flex flex-wrap items-center gap-4 text-[13px] text-white/60 font-medium" data-id="element-137">
            <div className="flex items-center gap-1.5" data-id="element-138">
              <ShieldCheck className="w-4 h-4 text-teal-400" data-id="element-139" />
              <span data-id="element-140">60-day money-back guarantee</span>
            </div>
            <span className="hidden sm:inline text-white/30" data-id="element-141">•</span>
            <div className="flex items-center gap-1.5" data-id="element-142">
              <Download className="w-4 h-4 text-teal-400" data-id="element-143" />
              <span data-id="element-144">Instant download</span>
            </div>
            <span className="hidden sm:inline text-white/30" data-id="element-145">•</span>
            <div className="flex items-center gap-1.5" data-id="element-146">
              <Users className="w-4 h-4 text-teal-400" data-id="element-147" />
              <span data-id="element-148">47,000+ users</span>
            </div>
          </div>
        </div>

        {/* Right Column - Image */}
        <div className="relative mx-auto w-full max-w-md lg:max-w-full" data-id="element-149">
          <div className="absolute inset-0 bg-teal-400/20 blur-[80px] rounded-full" data-id="element-150" />
          <img src="https://cdn.magicpatterns.com/uploads/c3GNTfJySRtbVSMvFSSmJW/The_11pm_Spine_Reset_eBook_Cover.png" alt="The 11PM Spine Reset eBook Cover" className="relative z-10 w-full h-auto rounded-lg shadow-2xl border border-white/10" data-id="element-151" />
        </div>
      </div>
    </section>;
}